import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Location } from "../../assets/location.svg";
import { authSelector } from "../../redux/slices/authSlice";
import {
  setCurrentId,
  getFloors,
  getItemizers,
  getCategoryItemizers,
  getPayments,
  getHouseAccounts,
  getCategories,
  getCompanies,
  getTaxes,
} from "../../redux/slices/companiesSlice";
import { useLocation } from "react-router-dom";
import {
  getItemizerCodesForToken,
  getItemizerRoute,
} from "../../utils/itemizerRules";

const LocationStyle = styled.div`
  background: ${({ bg }) => bg};
  color: white;
  padding: 16px;
  height: 120px;
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  font-size: 12px;
  border-radius: 6px;
  margin-right: 16px;
  margin-bottom: 16px;
  cursor: pointer;
  text-align: center;
`;

const LocationBarButton = ({ item, current }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { token } = useSelector(authSelector);

  const bg = current ? "#5187e0" : "#232a3b";

  const itemizerCodes = getItemizerCodesForToken({ token });
  const itemizerActions = itemizerCodes.reduce(
    (actions, code, index) => ({
      ...actions,
      [getItemizerRoute(code, index)]: () => getItemizers({ Itemizer: code }),
    }),
    { "/details/itemizers": () => getItemizers() }
  );

  const fnDict = {
    "/": () => getCompanies(),
    "/details": () => getFloors(),
    ...itemizerActions,
    "/details/category": () => getCategories(),
    "/details/payments": () => getPayments(),
    "/details/payments-cross-posting": () =>
      getPayments({ operation_id: "crossposting" }),
    "/details/tax": () => getTaxes(),
  };

  return (
    <LocationStyle
      bg={bg}
      onClick={() => {
        dispatch(setCurrentId(item.company_id));
        if (pathname in fnDict) {
          dispatch(fnDict[pathname]());
        }
        if (pathname === "/details/category") {
          dispatch(getCategoryItemizers());
        }
        if (
          pathname === "/details/payments" ||
          pathname === "/details/payments-cross-posting"
        ) {
          dispatch(getHouseAccounts());
        }
      }}
    >
      <Location fill="white" />
      <p>{item.company_name}</p>
    </LocationStyle>
  );
};

export default LocationBarButton;
